// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form_2lRdy","mobileFormCard":"Form_mobileFormCard_2XaE2"};